
















































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class SiteFooter extends Vue {
  public termsAndConditionsDialog: boolean = false;
}
